try {
    (() => {
        // HC custom: Afterpay info-modal brand pass (step icons, description copy, footer
        // annotation/link, "Xena checkout - Afterpay" badge). Added 2026-07-06, revised same day
        // after Dima flagged (1) the step-icon copy still read Afterpay's stock wording instead of
        // the mockup's condensed copy, and (2) the footer still showed Afterpay's full legal
        // paragraph instead of the mockup's short "Must be 18+... / See complete terms" version.
        // Companion to assets/hc-afterpay-modal.css (border-radius, headline/heading color+case,
        // close-button hit area, @font-face, fixed icon size).
        //
        // Why JS + inline styles instead of more CSS: live DOM inspection confirmed Afterpay's
        // own script re-asserts colors on the 3 step icons (raw SVG fill, hardcoded per-icon,
        // inconsistent class names) and on the footer annotation/link text AFTER our stylesheet
        // loads, so a plain CSS override loses the cascade tie. Setting the style via
        // el.style.setProperty(prop, val, 'important') always wins regardless of load order,
        // because an inline style always beats an external stylesheet. Text content (copy
        // rewrites) has to be JS regardless - CSS cannot change text.
        //
        // IMPORTANT - NO MutationObserver here, on purpose. A persistent MutationObserver on a
        // third-party, JS-driven component (the Shop Pay installments shadow DOM, in hc-global.js)
        // previously caused a re-render war that FROZE the Astra PDP on repeat navigation
        // (2026-06-09 - see feedback_no_observer_on_shopify_payment_terms.md and the
        // standardizeAfterpay()/burst() pattern in hc-global.js). Afterpay's info-modal is the
        // same kind of third-party component reasserting its own styles, so this uses the
        // identical proven-safe pattern instead: a short, BOUNDED burst of applyFixes() calls (a
        // handful of times over ~3s), triggered by user clicks - never by observing our own or
        // Afterpay's DOM mutations. It cannot enter a mutation feedback loop and cannot freeze the
        // page. Do not "improve" this by swapping in a MutationObserver.

        // Condensed step-copy, matches the approved mockup (replaces Afterpay's stock wording,
        // which is much longer - "Choose Afterpay at checkout and use your existing payment
        // card", etc). Order matches DOM order of the 3 process steps.
        var STEP_COPY = [
            'At checkout, with your existing card',
            'No long forms, instant decision',
            'Every two weeks, zero interest'
        ];

        function applyFixes() {
            var wrapper = document.querySelector('.afterpay_modal_wrapper');
            if (!wrapper) return;

            // 1) Step icons: fill colors are hardcoded per-icon inline (.st0 / .st1 classes,
            // inconsistent icon-to-icon), so walk every icon inside the 3 process steps.
            var processInners = wrapper.querySelectorAll('.c-afterpay-info-modal-process__inner');
            processInners.forEach(function (inner) {
                var svg = inner.querySelector('svg');
                if (svg) {
                    svg.querySelectorAll('.st0, .st1, path, circle, rect, polygon').forEach(function (shape) {
                        var cls = shape.getAttribute('class') || '';
                        if (cls.indexOf('st0') !== -1) {
                            shape.style.setProperty('fill', '#E4F5FC', 'important');
                        } else if (cls.indexOf('st1') !== -1) {
                            shape.style.setProperty('fill', '#1B79A4', 'important');
                        }
                    });
                }
            });

            // 1b) Step description copy: replace Afterpay's stock wording with the shorter,
            // approved copy. Idempotent (setting the same text every burst tick is a no-op after
            // the first successful pass) and defensive in case Afterpay ever re-renders this text.
            var copyEls = wrapper.querySelectorAll('.c-afterpay-info-modal-process__copy');
            copyEls.forEach(function (el, i) {
                if (STEP_COPY[i] && el.textContent.trim() !== STEP_COPY[i]) {
                    el.textContent = STEP_COPY[i];
                }
            });

            // 2) Footer: Afterpay's default is a full legal paragraph (18+/residency, taxes
            // disclaimer, "Click here for complete terms", CA finance-lender line, copyright).
            // The approved mockup shows a single short line + a "See complete terms" link.
            // Implementation: the ORIGINAL long paragraph is kept in the DOM (screen-reader
            // accessible, not display:none) but visually hidden, since it's Afterpay's own
            // required disclosure text and simply deleting it felt like the wrong call to make
            // unilaterally. The REAL <a> element (not a clone) is moved into a new short
            // paragraph and relabeled, so its actual href/behavior from Afterpay is preserved -
            // "See complete terms" still goes to Afterpay's real terms link.
            var annotation = wrapper.querySelector('.c-afterpay-info-modal-annotation');
            var annP = wrapper.querySelector('.c-afterpay-info-modal-annotation__p');
            var annA = wrapper.querySelector('.c-afterpay-info-modal-annotation__a');
            if (annotation && annP && annA && !annotation.querySelector('[data-hc-short-footer]')) {
                // Visually hide the original paragraph without removing it from the accessibility
                // tree (standard visually-hidden pattern - screen readers still read it).
                annP.style.setProperty('position', 'absolute', 'important');
                annP.style.setProperty('width', '1px', 'important');
                annP.style.setProperty('height', '1px', 'important');
                annP.style.setProperty('overflow', 'hidden', 'important');
                annP.style.setProperty('clip', 'rect(0,0,0,0)', 'important');
                annP.style.setProperty('white-space', 'nowrap', 'important');
                annP.style.setProperty('margin', '-1px', 'important');
                annP.style.setProperty('padding', '0', 'important');
                annP.style.setProperty('border', '0', 'important');

                var shortP = document.createElement('p');
                shortP.setAttribute('data-hc-short-footer', '');
                shortP.style.cssText = 'margin:0;text-align:center;font-size:12px;line-height:1.5;';
                shortP.appendChild(document.createTextNode('Must be 18+ and a U.S. resident. Late fees may apply. '));
                annA.textContent = 'See complete terms';
                shortP.appendChild(annA); // moves the real <a>, preserving its href/behavior
                annotation.appendChild(shortP);
            }
            // Color the short footer text + link every tick (Afterpay reasserts link color, per
            // the same pattern documented above).
            var shortP2 = wrapper.querySelector('[data-hc-short-footer]');
            if (shortP2) shortP2.style.setProperty('color', '#96979A', 'important');
            if (annA) {
                annA.style.setProperty('color', '#1B79A4', 'important');
                annA.style.setProperty('text-decoration', 'underline', 'important');
            }

            // 3) "Xena checkout - Afterpay" badge. Afterpay's markup has no such element, so this
            // inserts one - guarded by a data attribute so repeat burst ticks don't duplicate it.
            if (!wrapper.querySelector('[data-hc-afterpay-badge]')) {
                var badge = document.createElement('div');
                badge.setAttribute('data-hc-afterpay-badge', '');
                badge.setAttribute(
                    'style',
                    'display:inline-flex;align-items:center;gap:6px;' +
                    'background:#E4F5FC;color:#14283F;' +
                    'font-family:Inter,-apple-system,sans-serif;font-size:11px;font-weight:600;' +
                    'letter-spacing:0.04em;text-transform:uppercase;' +
                    'padding:6px 12px;border-radius:999px;margin:0 0 12px;box-sizing:border-box;'
                );
                badge.textContent = 'Xena checkout · Afterpay';
                wrapper.insertBefore(badge, wrapper.firstChild);
            }
        }

        var burstTimer = null;
        function burst() {
            if (burstTimer) clearInterval(burstTimer);
            var n = 0;
            applyFixes();
            burstTimer = setInterval(function () {
                n++;
                applyFixes();
                if (n >= 8) { clearInterval(burstTimer); burstTimer = null; }
            }, 350);
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', burst);
        } else {
            burst();
        }

        // Event-driven re-trigger: a click can open the modal. Afterpay controls its own trigger
        // markup/timing, so rather than guessing its exact selector, re-burst on every click -
        // applyFixes() is a cheap no-op (one querySelector) when the modal isn't open. Never
        // mutation-driven, so this cannot enter a re-render war or freeze the page.
        document.body.addEventListener('click', function () {
            setTimeout(burst, 50);
        });
    })();
} catch (e) {
    console.error(e);
}